<script>
import { mapActions, mapState } from "vuex";
import { getThemeId } from "@/store/downgrade/actions";
import { getThemeStyle, updateThemeStyle } from "@/services/global-style";
import { pageApi } from "@/services";
import Config from "@/config";

export default {
  name: 'StoreOnlineThemeChange',
  props: {
    themeName: {
      type: String,
      default: () => ''
    }
  },
  data: () => {
    return {
      showModal: false,
    }
  },
  computed: {
    ...mapState({
      publishedPagesCount: state => state.account.shopInfo?.publishedPagesCount
    }),
  },
  methods: {
    ...mapActions("common", {
      gSnackbarCommit: "gSnackbarCommit",
    }),
    async getPageId(orderBy, where) {
      const themeID = await getThemeId();
      const result = await pageApi.getThemePageApi({
        first: 1,
        orderBy: {
          field: orderBy.field,
          direction: orderBy.direction
        },
        ...where,
        themeID: themeID,
      });

      const edge = result?.data?.themePages?.edges[0]
      if (edge) {
        return {
          themeID,
          pageId: edge.node.id
        }
      }

      return null
    },
    async preview() {
      const res = await this.getPageId({
        field: 'PUBLISHED_AT',
        direction: 'DESC'
      }, {
        "where": {
          "publishedAtNotNil": true,
          "typeNotIn": ["STATIC"]
        },
      })

      if (res) {
        window.location.href = Config.getSetting("instantBaseURL") + `/editor/${res.themeID}/${res.pageId}?type=gempagesv7&global-style=preview_change`;
      } else {
        const res = await this.getPageId({
          field: 'UPDATED_AT',
          direction: 'DESC'
        }, {
          "where": {
            "typeNotIn": ["STATIC"]
          },
        })
        window.location.href = Config.getSetting("instantBaseURL") + `/editor/${res.themeID}/${res.pageId}?type=gempagesv7&global-style=preview_change`;
      }
    },
    close() {
      this.$emit('close')
    },
    async confirm() {
      this.showModal = false
      const themeID = await getThemeId();
      if (themeID) {
        const { id, data } = await this.themeStyleData(themeID)
        const themeRes = await updateThemeStyle(id, data)
        if (themeRes?.data?.themeStyleUpdate.id) {
          this.gSnackbarCommit({
            message: 'Successfully applied style from Shopify theme',
            type: 'success'
          })
        }
      }
    },
    async themeStyleData(themeID) {
      const res = await getThemeStyle(themeID)
      return {
        id: res.data.themeStyles?.edges[0].node.id,
        data: res.data.themeStyles?.edges[0].node.data
      }
    },
  }
}
</script>

<template>
  <div>
    <Modal v-if="showModal" m-class="p-0">
      <template #default>
        <div class="modal">
          <div class="header">
            <h1>Update global styles</h1>
            <svg @click="showModal = false" class="close" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2.64645 2.64645C2.84171 2.45118 3.15829 2.45118 3.35355 2.64645L13.3536 12.6464C13.5488 12.8417 13.5488 13.1583 13.3536 13.3536C13.1583 13.5488 12.8417 13.5488 12.6464 13.3536L2.64645 3.35355C2.45118 3.15829 2.45118 2.84171 2.64645 2.64645Z" fill="#676767"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3536 2.64645C13.5488 2.84171 13.5488 3.15829 13.3536 3.35355L3.35355 13.3536C3.15829 13.5488 2.84171 13.5488 2.64645 13.3536C2.45118 13.1583 2.45118 12.8417 2.64645 12.6464L12.6464 2.64645C12.8417 2.45118 13.1583 2.45118 13.3536 2.64645Z" fill="#676767"/>
            </svg>
          </div>
          <div class="content">
            <div class="alert">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 10C18.75 14.8325 14.8325 18.75 10 18.75C5.16751 18.75 1.25 14.8325 1.25 10C1.25 5.16751 5.16751 1.25 10 1.25C14.8325 1.25 18.75 5.16751 18.75 10ZM10.5835 5.76996C10.5835 6.11514 10.3037 6.39496 9.9585 6.39496C9.61332 6.39496 9.3335 6.11514 9.3335 5.76996C9.3335 5.42478 9.61332 5.14496 9.9585 5.14496C10.3037 5.14496 10.5835 5.42478 10.5835 5.76996ZM8.64136 6.98291C8.36521 6.98291 8.14136 7.20677 8.14136 7.48291C8.14136 7.75905 8.36521 7.98291 8.64136 7.98291H9.57507V13.1049C9.57507 13.6572 10.0228 14.1049 10.5751 14.1049H11.9643C12.2404 14.1049 12.4643 13.881 12.4643 13.6049C12.4643 13.3288 12.2404 13.1049 11.9643 13.1049H10.5751V7.98291C10.5751 7.43063 10.1274 6.98291 9.57507 6.98291H8.64136Z" fill="#2856F8"/>
              </svg>
              <span>We found that {{ publishedPagesCount }} published pages using global styles</span>
            </div>
            <div class="des">Your changes will be immediately affected to the published pages and draft pages that created by GemPages</div>
          </div>
          <div class="footer">
            <button class="btn btn-outline" @click="showModal = false">
              Cancel
            </button>
            <button @click="confirm" class="btn btn-primary">
              Confirm
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <div class="panel">
      <div class="close" v-popover:tooltip.top="'Don’t remind me again'">
        <svg @click="close" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2.64645 2.64645C2.84171 2.45118 3.15829 2.45118 3.35355 2.64645L13.3536 12.6464C13.5488 12.8417 13.5488 13.1583 13.3536 13.3536C13.1583 13.5488 12.8417 13.5488 12.6464 13.3536L2.64645 3.35355C2.45118 3.15829 2.45118 2.84171 2.64645 2.64645Z" fill="#212121"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3536 2.64645C13.5488 2.84171 13.5488 3.15829 13.3536 3.35355L3.35355 13.3536C3.15829 13.5488 2.84171 13.5488 2.64645 13.3536C2.45118 13.1583 2.45118 12.8417 2.64645 12.6464L12.6464 2.64645C12.8417 2.45118 13.1583 2.45118 13.3536 2.64645Z" fill="#212121"/>
        </svg>
      </div>
      <div class="left">
        <svg width="256" height="166" viewBox="0 0 256 166" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.913086" width="120" height="164" rx="8.34783" fill="white"/>
          <rect opacity="0.1" x="16.6957" y="116.391" width="25.5072" height="26.3694" rx="2.78261" fill="#262D39"/>
          <rect opacity="0.3" x="47.7681" y="116.391" width="25.5072" height="26.3694" rx="2.78261" fill="#262D39"/>
          <rect x="78.8406" y="116.391" width="25.5072" height="26.3694" rx="2.78261" fill="#262D39"/>
          <path d="M14.5268 64.1741L14.6395 63.7984L15.9919 63.4228C16.9936 63.1473 17.7199 62.5337 18.1706 61.5821L29.5905 39.381H32.6333L36.1644 61.5445C36.2646 62.421 36.7404 63.0471 37.5919 63.4228L38.5686 63.7984L38.4934 64.1741H29.0646L29.1773 63.7984L30.0037 63.4979C30.8802 63.1723 31.2433 62.5713 31.0931 61.6948L30.2291 55.6468H22.2277L19.0722 61.7323C18.8719 62.133 18.8343 62.4836 18.9595 62.7842C19.0847 63.0847 19.3477 63.2976 19.7484 63.4228L20.9129 63.7984L20.8378 64.1741H14.5268ZM28.5011 43.4756L22.6033 54.8955H30.1164L28.5011 43.4756ZM45.0943 64.7376C44.3931 64.7376 43.7295 64.5748 43.1034 64.2492C42.4773 63.9236 41.9639 63.3852 41.5632 62.6339C41.1876 61.8826 40.9997 60.8934 40.9997 59.6662C40.9997 58.3389 41.2627 57.0116 41.7886 55.6843C42.3145 54.332 43.0157 53.0548 43.8923 51.8527C44.7688 50.6256 45.7455 49.5487 46.8223 48.6221C47.8992 47.6704 49.0136 46.9191 50.1656 46.3682C51.3176 45.8172 52.407 45.5417 53.4338 45.5417C53.9347 45.5417 54.398 45.6419 54.8237 45.8422C55.2745 46.0175 55.7003 46.268 56.1009 46.5936L59.1437 45.429L59.4442 45.6169L56.1761 60.0043C56.0008 60.7056 55.9131 61.2816 55.9131 61.7323C55.9131 62.2582 56.151 62.5212 56.6269 62.5212C56.9775 62.5212 57.3782 62.3584 57.8289 62.0329C58.3048 61.7073 58.8432 61.269 59.4442 60.7181L59.7448 61.0186C59.3691 61.6196 58.8933 62.2082 58.3173 62.7842C57.7663 63.3351 57.1403 63.7984 56.439 64.1741C55.7629 64.5497 55.0366 64.7376 54.2603 64.7376C53.4088 64.7376 52.7201 64.4871 52.1942 63.9862C51.6683 63.4603 51.4053 62.6589 51.4053 61.5821C51.4053 61.2315 51.4178 60.8934 51.4429 60.5678C50.4411 61.6948 49.3768 62.6715 48.2498 63.4979C47.1479 64.3243 46.0961 64.7376 45.0943 64.7376ZM45.4324 57.9758C45.4324 59.3031 45.6453 60.2673 46.071 60.8683C46.5218 61.4443 47.1103 61.7323 47.8366 61.7323C48.4376 61.7323 49.0387 61.5445 49.6397 61.1689C50.2408 60.7932 50.8919 60.2548 51.5931 59.5536C51.6432 59.253 51.7058 58.94 51.7809 58.6144L54.1476 47.7956C53.822 47.3949 53.4338 47.1195 52.983 46.9692C52.5322 46.8189 52.1316 46.7438 51.7809 46.7438C50.7041 46.7438 49.5771 47.3824 48.4001 48.6596C47.4735 49.6864 46.7472 51.0388 46.2213 52.7167C45.6954 54.3946 45.4324 56.1476 45.4324 57.9758Z" fill="#373737"/>
          <rect opacity="0.6" x="65.3913" y="57.9565" width="38.9565" height="6.95652" rx="3.47826" fill="#DCE2EB"/>
          <rect opacity="0.6" x="16.6957" y="76.0435" width="87.6522" height="6.95652" rx="3.47826" fill="#DCE2EB"/>
          <rect opacity="0.6" x="16.6957" y="94.1304" width="87.6522" height="6.95652" rx="3.47826" fill="#DCE2EB"/>
          <circle cx="18.0869" cy="14.8261" r="2.78261" fill="#DBE1EA"/>
          <circle cx="27.8261" cy="14.8261" r="2.78261" fill="#DBE1EA"/>
          <circle cx="37.5652" cy="14.8261" r="2.78261" fill="#DBE1EA"/>
          <rect x="134.957" y="0.913086" width="120" height="164" rx="8.34783" fill="white"/>
          <path d="M154.869 64.5652H149.782L159.044 38.2569H164.927L174.202 64.5652H169.115L162.088 43.6521H161.883L154.869 64.5652ZM155.036 54.25H168.909V58.078H155.036V54.25ZM183.139 64.9634C181.889 64.9634 180.763 64.7407 179.761 64.2954C178.767 63.8415 177.979 63.1736 177.397 62.2915C176.823 61.4094 176.536 60.3218 176.536 59.0286C176.536 57.9153 176.742 56.9947 177.153 56.2668C177.564 55.5388 178.125 54.9565 178.836 54.5197C179.547 54.083 180.347 53.7533 181.238 53.5306C182.137 53.2994 183.066 53.1324 184.026 53.0296C185.182 52.9097 186.119 52.8027 186.839 52.7085C187.558 52.6057 188.081 52.4515 188.406 52.246C188.74 52.0319 188.907 51.7022 188.907 51.2569V51.1798C188.907 50.2121 188.62 49.4627 188.046 48.9318C187.473 48.4008 186.646 48.1353 185.567 48.1353C184.428 48.1353 183.525 48.3837 182.857 48.8804C182.197 49.3771 181.752 49.9637 181.521 50.6403L177.179 50.0237C177.521 48.8247 178.087 47.8228 178.874 47.0178C179.662 46.2042 180.626 45.5961 181.765 45.1936C182.904 44.7826 184.163 44.577 185.541 44.577C186.492 44.577 187.438 44.6884 188.38 44.911C189.322 45.1337 190.183 45.5019 190.962 46.0158C191.742 46.521 192.367 47.2104 192.838 48.084C193.317 48.9575 193.557 50.0494 193.557 51.3597V64.5652H189.087V61.8547H188.933C188.65 62.4028 188.252 62.9166 187.738 63.3962C187.233 63.8672 186.595 64.2483 185.824 64.5395C185.062 64.8221 184.167 64.9634 183.139 64.9634ZM184.347 61.5464C185.28 61.5464 186.089 61.3623 186.775 60.994C187.46 60.6172 187.986 60.1205 188.355 59.5039C188.731 58.8873 188.92 58.2151 188.92 57.4871V55.162C188.774 55.2819 188.526 55.3932 188.175 55.496C187.832 55.5988 187.447 55.6887 187.019 55.7658C186.59 55.8429 186.167 55.9114 185.747 55.9713C185.327 56.0313 184.963 56.0826 184.655 56.1255C183.961 56.2197 183.34 56.3738 182.792 56.5879C182.244 56.802 181.812 57.1017 181.495 57.4871C181.178 57.8639 181.02 58.3521 181.02 58.9515C181.02 59.8079 181.332 60.4545 181.957 60.8913C182.583 61.328 183.379 61.5464 184.347 61.5464Z" fill="#373737"/>
          <rect opacity="0.6" x="201.739" y="57.9565" width="37.5652" height="6.95652" rx="3.47826" fill="#DCE2EB"/>
          <rect opacity="0.6" x="151.652" y="76.0435" width="87.6522" height="6.95652" rx="3.47826" fill="#DCE2EB"/>
          <rect opacity="0.6" x="151.652" y="94.1304" width="87.6522" height="6.95652" rx="3.47826" fill="#DCE2EB"/>
          <rect opacity="0.3" x="151.652" y="116.391" width="25.5072" height="26.3694" rx="2.78261" fill="#B692FE"/>
          <rect opacity="0.5" x="182.725" y="116.391" width="25.5072" height="26.3694" rx="2.78261" fill="#6E26FD"/>
          <rect x="213.797" y="116.391" width="25.5072" height="26.3694" rx="2.78261" fill="#6E26FD"/>
          <circle cx="151.652" cy="14.8261" r="2.78261" fill="#DBE1EA"/>
          <circle cx="161.391" cy="14.8261" r="2.78261" fill="#DBE1EA"/>
          <circle cx="171.13" cy="14.8261" r="2.78261" fill="#DBE1EA"/>
          <rect x="114.783" y="69.8692" width="26.4348" height="26.4348" rx="13.2174" fill="white"/>
          <path d="M130.207 79.1363C129.998 78.938 129.659 78.938 129.45 79.1363C129.241 79.3346 129.241 79.6562 129.45 79.8546L132.306 82.5649L122.107 82.5649C121.819 82.5649 121.585 82.7985 121.585 83.0867C121.585 83.3748 121.819 83.6084 122.107 83.6084L132.306 83.6084L129.45 86.3189C129.241 86.5172 129.241 86.8388 129.45 87.0371C129.659 87.2355 129.998 87.2355 130.207 87.0371L133.991 83.4458C134.2 83.2475 134.2 82.9259 133.991 82.7276L130.207 79.1363Z" fill="#676767"/>
          <rect x="114.783" y="69.8692" width="26.4348" height="26.4348" rx="13.2174" stroke="#C6CDD5" stroke-width="1.3913"/>
        </svg>

      </div>
      <div class="right">
        <h1>
          You have changed to
          {{ themeName }}
        </h1>
        <span>
          Do you want to apply new theme styles to all GemPages templates?
        </span>
        <div class="btn-box">
          <button class="preview" @click="preview">
            Preview changes
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.modal {
  background: #ffffff;
  width: 600px;
  border-radius: 3px;

  .header {
    padding: 16px;
    position: relative;

    .close {
      cursor: pointer;
      position: absolute;
      top: 20px;
      right: 20px;
    }

    h1 {
      font-size: 16px;
      font-weight: 500;
      color: #212121;
    }
  }

  .content {
    padding-left: 16px;
    padding-right: 16px;
    border-top: 1px solid #EDEDED;
    border-bottom: 1px solid #EDEDED;

    .alert {
      background: #D8E1FF;
      border-radius: 3px;
      height: 53px;
      padding: 16px;
      color: #212121;
      font-weight: 400;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: start;
      column-gap: 8px;
      margin-top: 16px;
      margin-bottom: 16px;
    }

    .des {
      color: #212121;
      font-weight: 400;
      font-size: 14px;
      margin-bottom: 16px;
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: end;
    column-gap: 8px;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-right: 16px;

    button {
      height: 40px;
    }
  }
}

.panel {
  background: #FFFFFF;
  border-radius: 3px;
  display: flex;
  position: relative;
  border: 1px solid #D6D6D6;
  margin-bottom: 32px;

  .close {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
    width: 32px;
    height: 32px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }

  .left {
    padding: 24px;
    background: #CACFDC;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  .right {
    display: flex;
    align-items: start;
    justify-content: center;
    flex-direction: column;
    padding: 24px;

    h1 {
      color: #212121;
      font-weight: 600;
      font-size: 18px;
      font-style: normal;
    }

    span {
      font-size: 14px;
      font-weight: 400;
      color: #676767;
      margin-top: 8px;
      margin-bottom: 16px;
    }

    .preview {
      background: #323232;
      border-radius: 3px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0 24px;
      height: 40px;
      color: #FFFFFF;
      font-weight: 500;
      font-size: 14px;
      border: none;
      cursor: pointer;

      &:hover {
        background: #5B5B5B;
      }
    }

    .update-all {
      background: #F4F4F4;
      border-radius: 3px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0 24px;
      height: 40px;
      color: #212121;
      font-weight: 500;
      font-size: 14px;
      border: none;
      cursor: pointer;

      &:hover {
        background: #DCDCDC;
      }
    }

    .btn-box {
      display: flex;
      column-gap: 8px;
      width: 100%;
    }
  }
}
</style>
